// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  barSlot: "SectionScenarioSquares__barSlot",
  blurb: "SectionScenarioSquares__blurb",
  calloutText: "SectionScenarioSquares__calloutText",
  caption: "SectionScenarioSquares__caption",
  chartTitle: "SectionScenarioSquares__chartTitle",
  figures: "SectionScenarioSquares__figures",
  grid: "SectionScenarioSquares__grid",
  gridSlot: "SectionScenarioSquares__gridSlot",
  keyRow: "SectionScenarioSquares__keyRow",
  name: "SectionScenarioSquares__name",
  paper: "SectionScenarioSquares__paper",
  row: "SectionScenarioSquares__row",
  rows: "SectionScenarioSquares__rows",
  section: "SectionScenarioSquares__section",
  sq: "SectionScenarioSquares__sq",
  taskKey: "SectionScenarioSquares__taskKey",
  waffleLabel: "SectionScenarioSquares__waffleLabel",
  wallCap: "SectionScenarioSquares__wallCap",
  who: "SectionScenarioSquares__who",
  you: "SectionScenarioSquares__you",
  youOutline: "SectionScenarioSquares__youOutline",
};
